import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface TablerIconEditIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const TablerIconEditIcon = ({ className, ...props }: TablerIconEditIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 7H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1M16 5l3 3m1.385-1.415a2.1 2.1 0 0 0-2.97-2.97L9 12v3h3z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default TablerIconEditIcon;
